<template>
    
    <div>
      
      <v-simple-table
        fixed-header
        class="pa-6"
      >
        
        <template v-slot:default>
        
          <thead>
        
            <tr>
              <th class="text-left">Curso</th>
              <th class="text-left">Idioma</th>
              <th class="text-left">Nivel</th>
              <th class="text-left">Días</th>
              <th class="text-left">Horario</th>
              <th class="text-left">Nota junio</th>
              <th class="text-left">Nota septiembre</th>
              <th class="text-center">Observaciones</th>
            </tr>
        
          </thead>
        
          <tbody>
        
            <tr v-for="item in items" :key="item.id">
              <td class="text-left">{{ item.curso.anio }}</td>
              <td class="text-left">{{ item.nivel.idioma.nombre }}</td>
              <td class="text-left">{{ item.nivel.descripcion }}</td>
              <td class="text-left">{{ item.grupo != null ? item.grupo.dia.descripcion : '' }}</td>
              <td class="text-left">{{ item.grupo != null ? item.grupo.horario.descripcion : '' }}</td>
              <td class="text-left" >{{ item.notaJunio != null ? item.notaJunio.descripcion : ''}}</td>
              <td class="text-left">{{ item.notaSeptiembre != null ? item.notaSeptiembre.descripcion : ''}}</td>
              <td class="text-center" v-if="item.observaciones">
                  <v-dialog v-if="item.observaciones != null && item.observaciones.length > 0" 
                      scrollable 
                      max-width="600px" 
                      :key="item.id" 
                  >

                    <template v-slot:activator="{ on, attrs }">
                  
                      <v-btn 
                        small
                        color="primary" 
                        icon
                        dark 
                        v-bind="attrs"
                        v-on="on"
                      >
                      
                        <v-icon
                          small
                        >
                      
                          mdi-information-outline
                      
                        </v-icon>
                      
                      </v-btn>  

                    </template>
                    
                    <v-card>
                      
                      <v-card-title>Observaciones</v-card-title>
                      
                      <v-divider></v-divider>
                      
                      <v-card-text style="height: 300px;" v-html="nl2brObservaciones(item.observaciones)">

                        

                      </v-card-text>
                      
                    </v-card>

                  </v-dialog>

                </td>
              <td v-else></td>
            </tr>
        
          </tbody>
        
        </template>
      
      </v-simple-table>

    </div>

</template>

<script>

import { getByAlumno } from '@/api/matriculas.api'

export default {
  name: 'PersonaForm',
  props: {
    item: {
      type: Object,
      required: true,
    },

    userCanEdit: {
      type: Boolean,
      required: true
    }

  },

  data: () => {
      return {
          items: []
      }
  },

  async created(){
    await this.initialize()
  },

  methods: {
      
      async initialize() {
          this.items = await getByAlumno(this.item.id)
            .then(response => this.items = response.data.reverse())
            .catch(error => console.error(error))
      },

      nl2brObservaciones(str) {
        return `<p class="pa-4">${str.replace(/(?:\r\n|\r|\n)/g, '<br />')}</p>`
      }

  }

}

</script>